import { fromJS, OrderedSet, Record, Set } from 'immutable'

export const ValueRecord = Record({
  id: null,
  name: null,
  proTracksCount: 0,
  activeUsers: 0,
  globalValue: null,
  proTracks: Set(),
  globalValueField: null,
  globalValueId: null,
})

export class Value extends ValueRecord {}

export const initialState = fromJS({
  all: {},
  view: null,
  editForm: false,
  pagination: {
    current: 0,
    perPage: 6,
  },
  ids: OrderedSet(),
  sort: {
    by: null,
    desc: false,
  },
  pending: {
    getAll: false,
    get: false,
    patch: false,
    delete: false,
    post: false,
  },
  loaded: {
    getAll: false,
  },
  error: null,
  idToDelete: null,
})
